import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DotsHorizontal, Close } from '../../../../assets/images/index';
import {
  StyledIconPoints,
  StyledOptionsClose,
  StyledOptionsIcons,
  StyledOptionsIconsColumn,
  StyledOptionsNews
} from './style';

class OptionsNews extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  render() {
    const {
      className,
      onFavorite,
      onLike,
      activeLike,
      activeFavorite,
      onShare,
      onComment,
      numberIcon,
      isHome,
      readAfter,
      likesNumber,
      hastoken
    } = this.props;

    const OptionIcons = readAfter
      ? StyledOptionsIconsColumn
      : StyledOptionsIcons;

    return (
      <StyledOptionsNews
        className={`${className} OptionsNews`}
        readAfter={readAfter}
      >
        <StyledIconPoints
          svg={DotsHorizontal}
          size="m"
          onClick={this.onClick}
          readAfter={readAfter}
          hover
        />
        <OptionIcons
          activeLike={activeLike}
          activeFavorite={activeFavorite}
          onLike={onLike}
          onComment={onComment}
          onFavorite={onFavorite}
          onShare={onShare}
          numberIcon={numberIcon}
          readAfter={readAfter}
          activeMobile={this.state.active}
          isHome={isHome}
          likesNumber={likesNumber}
          hastoken={hastoken}
        >
          <StyledOptionsClose
            svg={Close}
            color="primary"
            onClick={this.onClick}
            readAfter={readAfter}
            activeMobile={this.state.active}
          />
        </OptionIcons>
      </StyledOptionsNews>
    );
  }
}

OptionsNews.propTypes = {
  className: PropTypes.string,
  activeFavorite: PropTypes.bool,
  activeLike: PropTypes.bool,
  onShare: PropTypes.func,
  onLike: PropTypes.func,
  onComment: PropTypes.func,
  onFavorite: PropTypes.func,
  numberIcon: PropTypes.number,
  readAfter: PropTypes.bool,
  hastoken: PropTypes.bool
};

export default OptionsNews;
